/* Import TinyMCE */
import tinymce from 'tinymce';

/* Default icons are required for TinyMCE 5.3 or above */
import 'tinymce/icons/default';

/* A theme is also required */
import 'tinymce/themes/silver';

/* Import the skin */
import 'tinymce/skins/ui/oxide/skin.css';

/* Import plugins */
// import 'tinymce/plugins/advlist';
// import 'tinymce/plugins/code';
// import 'tinymce/plugins/emoticons';
// import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
// import 'tinymce/plugins/table';

/* Import premium plugins */
/* NOTE: Download separately and add these to /src/plugins */
/* import './plugins/checklist/plugin'; */
/* import './plugins/powerpaste/plugin'; */
/* import './plugins/powerpaste/js/wordimport'; */

/* Import content css */
import contentUiCss from '!!raw-loader!tinymce/skins/ui/oxide/content.css';
import contentCss from '!!raw-loader!tinymce/skins/content/default/content.css';

/* Initialize TinyMCE */
export function render () {
    tinymce.init({
        selector:'textarea[data-tinymce]',
        promotion: false,
        language: 'sv_SE',
        menu: {
            file: { title: 'File', items: 'restoredraft | preview | export print' },
            edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall | searchreplace' },
            view: { title: 'View', items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments' },
            insert: { title: 'Insert', items: 'image link media addcomment pageembed template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor tableofcontents | insertdatetime' },
            format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript | styles blocks fontfamily fontsize | forecolor backcolor | language | removeformat' },
            //tools: { title: 'Tools', items: 'spellchecker spellcheckerlanguage | a11ycheck code wordcount' },
            //table: { title: 'Table', items: 'inserttable | cell row column | advtablesort | tableprops deletetable' },
            //help: { title: 'Help', items: 'help' }
        },
        toolbar: 'undo redo | styles | bold italic | link image',
        paste_data_images: false,
        paste_as_text: true,
        skin: false,
        content_css: false,
        content_style: contentUiCss.toString() + '\n' + contentCss.toString(),
        height: 300,
        plugins: 'link lists autolink',
        link_default_target: '_blank'
    });
};
